













import { Client } from 'client-website-ts-library/services';
import { APIRequest, APIRequestMethod } from 'client-website-ts-library/services/API/APIRequest';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GoogleReviews extends Vue {
  private reviews: GoogleReview[] = [];;

  mounted() {
    // Client.Request(new APIRequest(APIRequestMethod.GET, '/api/testimonials/location/ChIJ8-UY_49meGkR20LMiN6dMO4'));

    // this.GetReviews('https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJ8-UY_49meGkR20LMiN6dMO4&fields=name,rating,formatted_phone_number,reviews&key=AIzaSyA2dAxiqy0WguFJIt4r6-VyVqvUTmAuXLA').then((data) => console.log(data));
  }

  async GetReviews(url: string) {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
        'Access-Control-Allow-Headers': 'X-Requested-With, content-type, Authorization',
      },
    });
    return response.json(); // get JSON from the response
  }

  async created() {
    // Simple GET request using fetch
    // const response = await fetch('https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJ8-UY_49meGkR20LMiN6dMO4&fields=name,rating,formatted_phone_number,reviews&key=AIzaSyA2dAxiqy0WguFJIt4r6-VyVqvUTmAuXLA');
    // const data = await response.json();
    // this.reviews = data.total;
  }

  async getData() {
    try {
      console.log(11111111111111111111111111111111111111111111111111111111111111111111);
      const response = await fetch(
        'https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJ8-UY_49meGkR20LMiN6dMO4&fields=name,rating,formatted_phone_number,reviews&key=AIzaSyA2dAxiqy0WguFJIt4r6-VyVqvUTmAuXLA',
      );
      console.log(2222222222222222222222222222222222222222222222222222222222222222);
      alert(response);
    } catch (error) {
      console.log(error);
    }
  }
}

interface GoogleReview {
    author_name: string;
    author_url: string;
    profile_photo_url: string;
    rating: string;
    relative_time_description: string;
    text: string;
    time: string;
}
